<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            <slot name="body">
              <div class="" role="main">
                <div class="page-title">
                  <h3>{{ $t('accountManagementPage.authorityList') }}</h3>
                </div>
                <div class="row">
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="x_panel">
                      <div class="x_content">
                        <table
                          class="table table-condensed table-striped table-bordered"
                        >
                          <thead>
                            <tr>
                              <th class="col-xs-10" style="vertical-align: top">
                                {{ $t('accountManagementPage.screen') }}
                              </th>
                              <th class="col-xs-2 text-center">
                                {{ $t('common.select') }}
                                <div class="checkbox">
                                  <label class="no-padding">
                                    <input
                                      @change="allCheck"
                                      class="flat"
                                      type="checkbox"
                                      name="all"
                                    />
                                    {{ $t('accountManagementPage.all') }}
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index, key) in authorityParams"
                              :key="key"
                            >
                              <td>{{ item.viewName }}</td>
                              <td class="mid_center">
                                <div class="checkbox">
                                  <label class="no-padding">
                                    <input
                                      v-model="item.authority"
                                      class="flat"
                                      type="checkbox"
                                      name="auth"
                                    />
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="text-right">
                          <button
                            @click="$emit('close')"
                            class="btn btn-default dialogbtn_cancel"
                          >
                            {{ $t('common.cancel') }}
                          </button>
                          <button
                            @click="add"
                            class="btn btn-primary dialogbtn"
                          >
                            {{ $t('common.add') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: ['authorityParams'],
  methods: {
    allCheck: function(event) {
      const checkBoxes = document.getElementsByName('auth')
      checkBoxes.forEach((element) => {
        element.checked = event.target.checked
      })
      this.authorityParams.forEach((authorityParam, index) => {
        this.authorityParams[index] = {
          ...authorityParam,
          authority: event.target.checked,
        }
      })
    },
    add: function() {
      this.$emit('authorityInput', this.authorityParams)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  text-align: left;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  max-height: 80%;
  overflow-y: auto;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  max-height: 80%;
  overflow-y: hidden;
}
.modal-body .page-title {
  width: auto;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
